import ControlFactory from '@/Factories/ControlFactory';
import Factory from '@/Factories/Factory';
import ComponentManager from '@/Management/ComponentManager';
import EncryptedBox from '@/Controls/EncryptedBox';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import EncryptedBoxViewModel from '@/ViewModels/Controls/EncryptedBoxViewModel';

export default class EncryptedBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private EncryptedBoxViewModel = ComponentManager.getViewModel<typeof EncryptedBoxViewModel>('EncryptedBoxViewModel');
    private EncryptedBox = ComponentManager.getControl<typeof EncryptedBox>('EncryptedBox');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    protected ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModel>('ImageViewModel');

    public controlFactory: ControlFactory;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: EncryptedBox;
    /**
     * @override
     */
    viewModel: EncryptedBoxViewModel;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = $('<div class="c-encryptedbox-wrapper">');

        let value = this.context.genericObject.getValue(this.detailViewItem.name);

        if (value != null && value.split(';').length === 5) {
            let parameter = value.split(';');
            let property = parameter[0];
            let isEncryptable = parameter[1] === 'True';
            let uiFactory = parameter[2];
            let typeName = parameter[3];
            let propertyPath = parameter[4];

            if (uiFactory != null) {
                this.controlFactory = Factory.createInstance(uiFactory, {
                    detailViewItem: {
                        name: this.detailViewItem.name.replace('Value', property) + '.Value',
                        dotNetTypeName: this.detailViewItem.name.replace('Value', 'EmbeddedType')
                    },
                    context: this.context,
                    isFocusable: false
                }) as ControlFactory;

                let tuple = this.controlFactory.getTuple();
                this.jQueryControl.append(tuple.control);
            }

            this.viewModel = new this.EncryptedBoxViewModel({
                factory: this,
                isRequired: this.isRequired,
                image: new this.ImageViewModel({
                    source: 'lock.png',
                    alternativeText: new this.LabelViewModel({
                        ergName: 'LOCKEDOVERLAY_LABEL'
                    })
                }),
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                label: new this.LabelViewModel({
                    ergName: 'LOCKEDOVERLAY_LABEL'
                }),
                isVisible: !isEncryptable
            });

            this.control = new this.EncryptedBox(this.viewModel);

            let encryptionTuple = this.control.getTuple();
            this.jQueryControl.append(encryptionTuple.control);

            this.registerDefaultValidation([this.detailViewItem.name]);
        }

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('EncryptedBox', EncryptedBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');